import {
  AdClicksTooltip,
  DaysOnMarketTooltip,
  ImpressionsTooltip,
  LeadsTooltip,
  ListingViewsTooltip,
  WebsiteReferralsTooltip,
} from '../Tooltips';
import { Paragraph } from '@zillow/constellation-10';
import type { DailyStatsBreakdownRow } from './DailyStatsBreakdownTable';
import type { ReactNode } from 'react';

export type ColumnConfig<T> = {
  dataKey: keyof T & string;
  align?: 'left' | 'center' | 'right';
  width?: number;
  header: string;
  headerRenderer?: () => ReactNode;
  renderer?: (data: T) => ReactNode;
  isSortable?: boolean;
};

export const multiFamilyColumnConfig: Array<ColumnConfig<DailyStatsBreakdownRow>> = [
  {
    dataKey: 'reportDate',
    align: 'left',
    width: 1,
    header: 'Date',
    renderer: (data) => data.reportDate.toLocaleDateString(),
    isSortable: true,
  },
  {
    dataKey: 'impressionCount',
    align: 'left',
    width: 1,
    header: 'Impressions',
    headerRenderer: ImpressionsTooltip,
    renderer: (data) =>
      typeof data.impressionCount === 'number' && data.impressionCount > -1 ? data.impressionCount : '-',
    isSortable: true,
  },
  {
    dataKey: 'viewCount',
    align: 'left',
    width: 1,
    header: 'Listing Views',
    headerRenderer: ListingViewsTooltip,
    renderer: (data) => (typeof data.viewCount === 'number' && data.viewCount > -1 ? data.viewCount : '-'),
    isSortable: true,
  },
  {
    dataKey: 'leadCount',
    align: 'left',
    width: 1,
    header: 'Leads',
    renderer: (data) => (
      <div>
        <Paragraph textStyle="body-bold">{`${data.leadCount} total`}</Paragraph>
        <Paragraph>{`${data.phoneLeadCount} phone`}</Paragraph>
        <Paragraph>{`${data.emailLeadCount} email`}</Paragraph>
      </div>
    ),
    headerRenderer: LeadsTooltip,
    isSortable: true,
  },
  {
    dataKey: 'listingWebReferrals',
    align: 'left',
    width: 1,
    header: 'Listing Web Referrals',
    headerRenderer: WebsiteReferralsTooltip,
    isSortable: true,
  },
  {
    dataKey: 'adClicks',
    align: 'left',
    width: 1,
    header: 'Ad Clicks',
    headerRenderer: AdClicksTooltip,
    isSortable: true,
  },
];

export const singleFamilyColumnConfig: Array<ColumnConfig<DailyStatsBreakdownRow>> = [
  ...multiFamilyColumnConfig,
  {
    dataKey: 'daysOnMarketCount',
    align: 'left',
    width: 1,
    header: 'Days on market',
    headerRenderer: DaysOnMarketTooltip,
    isSortable: true,
  },
];
